import SkeletonImage from 'antd/es/skeleton/Image';
import { withConfigProvider } from '../config-provider';
export default withConfigProvider(SkeletonImage);
